import type { SystemStyleObject } from "@ecco/ui/types";
import type { Part } from "./types";

export const styles: Record<Part, SystemStyleObject> = {
    input: {
        w: ["full", "full", "50%"],
    },
    button: {
        w: ["50%", "50%", "fit-content"],
    },
};
